export default {
  pageTitle: {
    basic: 'Basic signature details',
    social: 'Social media links',
    options: 'Signature options',
    addons: 'Signature addons',
    projects: 'Projects'
  },
  sidebar: {
    basic: 'Basic',
    social: 'Social',
    options: 'Options',
    addons: 'Addons',
    projects: 'Projects'
  }
};
